import React, { useEffect, useMemo, useState } from "react";
import "./banking.css";

const BankingPartner = () => {
  const [selectedLoanType, setSelectedLoanType] = useState("all");
  const [filteredPartners, setFilteredPartners] = useState([]);

  /* 🔹 PAGINATION STATES (NEW – DOES NOT TOUCH EXISTING) */
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const partners = [
    {
      sr: 1,
      fullname: "State Bank of India",
      sortname: "SBI",
      type: "Nationalized Bank",
      products: ["Home Loan", "Loan Against Property"],
      policyFile: {
        label: "sbi-policy.txt",
        url: "/policies/sbi-policy.pdf",
        type: "pdf",
      },
      rates: {
        home: "8.5%",
        lap: "9.1%",
      },
      code: "SBI123",
      payout: "0.35%",
    },
    {
      sr: 2,
      fullname: "Housing Development Finance Corporation",
      sortname: "HDFC",
      type: "Private Bank",
      products: [
        "Home Loan",
        "Loan Against Property",
        "Personal Loan",
        "Business Loan",
      ],
      policyFile: {
        label: "HDFC Loan Policy",
        url: "/policies/hdfc-policy.pdf",
        type: "hdfc-policy.pdf",
      },
      code: "HDFC456",
      rates: {
        home: "8.75%",
        personal: "11.7%",
        business: "12.2%",
        lap: "9.4%",
      },
      payout: "0.5%",
    },
    {
      sr: 3,
      fullname: "Bank Of Baroda",
      sortname: "BOB",
      type: "Nationalized Bank",
      products: ["Personal Loan", "Loan Against Property"],
      policyFile: {
        label: "BOB Loan Policy",
        url: "/policies/bob-policy.pdf",
        type: "pdf",
      },
      rates: {
        personal: "12.1%",
        lap: "9.3%",
      },
      code: "BOB789",
      payout: "0.4%",
    },
  ];

  const loanTypes = [
    { id: "all", label: "All", match: null },
    { id: "home", label: "Home Loan", match: "Home Loan" },
    { id: "personal", label: "Personal Loan", match: "Personal Loan" },
    { id: "lap", label: "Loan Against Property", match: "Loan Against Property" },
    { id: "business", label: "Business Loan", match: "Business Loan" },
    { id: "car", label: "Car Loan", match: "Car Loan" },
    { id: "education", label: "Education Loan", match: "Education Loan" },
    { id: "insta", label: "Insta Loan", match: "Insta Loan" },
  ];

  useEffect(() => {
    if (selectedLoanType === "all") {
      setFilteredPartners(partners);
    } else {
      const selected = loanTypes.find(
        (loan) => loan.id === selectedLoanType
      );

      const filtered = partners.filter((partner) =>
        partner.products.includes(selected.match)
      );

      setFilteredPartners(filtered);
    }

    /* 🔹 reset page on filter change */
    setCurrentPage(1);
  }, [selectedLoanType]);

  const getRateByLoanType = (partner) => {
    if (selectedLoanType === "all") return "-";
    return partner.rates[selectedLoanType] || "-";
  };

  const PolicyDownloadButton = ({ policy }) => {
    if (!policy) return <span style={{ color: "#999" }}>Not Available</span>;

    return (
      <a
        href={policy.url}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="policy-btn"
      >
        <img src="/images/pdf.png" width="40" height="auto" alt="Download" className="" />
      </a>
    );
  };

  const maskCode = (code) => {
    if (!code) return "-";
    return `XXX${code.slice(-2)}`;
  };

  /* ================= PAGINATION LOGIC (NEW) ================= */
  const totalPages = Math.ceil(filteredPartners.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedPartners = filteredPartners.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    console.log("Loan Type:", selectedLoanType);
    console.log("Search Term:", searchTerm);

    // 👉 filter logic or API call here
  };

  // 🔍 Filter Logic
  const filteredPartnerss = useMemo(() => {
    return partners.filter((partner) =>
      partner.fullname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      partner.sortname.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, partners]);

  useEffect(() => {
    setFilteredPartners(filteredPartnerss);
  }, [filteredPartnerss]);

  return (
    <div className="banking">
      <h1>Our Banking Partners</h1>

      {/* Loan Type Filter */}
      {/* <div className="hp-sticky-wrapper">
        <div className="hp-sticky-inner">
          <div className="hp-nav">
            {loanTypes.map((loanType) => (
              <button
                key={loanType.id}
                className={`hp-link ${selectedLoanType === loanType.id ? "active" : ""
                  }`}
                onClick={() => setSelectedLoanType(loanType.id)}
              >
                {loanType.label}
              </button>
            ))}
          </div>
        </div>
      </div> */}
      <div className="hp-sticky-wrapper">
        <div className="hp-sticky-inner">
          <div className="hp-nav hp-search-bar">

            {/* Search Input */}
            <div className="hp-search-group">
              <input
                type="text"
                className="hp-search-input"
                placeholder="Search bank"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              {/* Search Button */}
              <button
                className="apply-btn"
                onClick={handleSearch}
              >
                Search
              </button>
            </div>

            {/* Loan Type Dropdown */}
            <div>
              <select
                className="hp-dropdown"
                value={selectedLoanType}
                onChange={(e) => setSelectedLoanType(e.target.value)}
              >
                {loanTypes.map((loanType) => (
                  <option key={loanType.id} value={loanType.id}>
                    {loanType.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="banking-container">
        <div className="banking-content">
          <table className="banking-table">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Bank Name</th>
                {selectedLoanType !== "all" && <th>Rate of Interest</th>}
                <th>Loan Policy</th>
                <th>Code</th>
                <th>Payout</th>
              </tr>
            </thead>
            <tbody>
              {paginatedPartners.length > 0 ? (
                paginatedPartners.map((partner, index) => (
                  <tr key={index}>
                    <td>{startIndex + index + 1}</td>
                    <td>
                      {partner.sortname} ( {partner.fullname} )
                    </td>
                    {selectedLoanType !== "all" && (
                      <td>{getRateByLoanType(partner)}</td>
                    )}
                    <td style={{ textAlign: "center" }}>
                      <PolicyDownloadButton policy={partner.policyFile} />
                    </td>
                    <td style={{ fontWeight: "600" }}>
                      {maskCode(partner.code)}
                    </td>
                    <td>{partner.payout}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No banks available for this loan type
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* 🔹 PAGINATION UI */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                disabled={currentPage === 1}
                className="toggle-btn"
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="#000" viewBox="0 0 640 640"><path d="M105.4 297.4C92.9 309.9 92.9 330.2 105.4 342.7L265.4 502.7C277.9 515.2 298.2 515.2 310.7 502.7C323.2 490.2 323.2 469.9 310.7 457.4L173.3 320L310.6 182.6C323.1 170.1 323.1 149.8 310.6 137.3C298.1 124.8 277.8 124.8 265.3 137.3L105.3 297.3zM457.4 137.4L297.4 297.4C284.9 309.9 284.9 330.2 297.4 342.7L457.4 502.7C469.9 515.2 490.2 515.2 502.7 502.7C515.2 490.2 515.2 469.9 502.7 457.4L365.3 320L502.6 182.6C515.1 170.1 515.1 149.8 502.6 137.3C490.1 124.8 469.8 124.8 457.3 137.3z" /></svg>
              </button>

              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  className={currentPage === i + 1 ? "active" : ""}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
                className="toggle-btn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="#000" width={20} height={20} viewBox="0 0 640 640"><path d="M535.1 342.6C547.6 330.1 547.6 309.8 535.1 297.3L375.1 137.3C362.6 124.8 342.3 124.8 329.8 137.3C317.3 149.8 317.3 170.1 329.8 182.6L467.2 320L329.9 457.4C317.4 469.9 317.4 490.2 329.9 502.7C342.4 515.2 362.7 515.2 375.2 502.7L535.2 342.7zM183.1 502.6L343.1 342.6C355.6 330.1 355.6 309.8 343.1 297.3L183.1 137.3C170.6 124.8 150.3 124.8 137.8 137.3C125.3 149.8 125.3 170.1 137.8 182.6L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7z" /></svg>
              </button>
            </div>
          )}
        </div>
      </div>

      <section section className="banks-partner-section" >
        <div className="section-header">
          <h2>Our 100+ Banking Partners</h2>
          <p>Trusted by India's Leading Financial Institutions</p>
        </div>

        <div className="banks-listing-container">
          {/* First Row */}
          <ul
            className="banks-row-1"
            onMouseEnter={() => {
              const row = document.querySelector('.banks-row-1');
              if (row) row.style.animationPlayState = 'paused';
            }}
            onMouseLeave={() => {
              const row = document.querySelector('.banks-row-1');
              if (row) row.style.animationPlayState = 'running';
            }}
          >
            <li><img src="/bank-logos/hdfc8.png" alt="HDFC Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/piramal3.png" alt="Piramal Finance" className="bank-logo" /></li>
            <li><img src="/bank-logos/Union.png" alt="Union Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/dcb.png" alt="DCB Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/incre.png" alt="Incred Finance" className="bank-logo" /></li>
            <li><img src="/bank-logos/sbi.png" alt="SBI" className="bank-logo" /></li>
            <li><img src="/bank-logos/icici.png" alt="ICICI Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/axis3.png" alt="Axis Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/yes.png" alt="Yes Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/bajaj.png" alt="Bajaj Finserv" className="bank-logo" /></li>
            <li><img src="/bank-logos/bob3.png" alt="Bank of Baroda" className="bank-logo" /></li>
            <li><img src="/bank-logos/kotak.png" alt="Kotak Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/idfc.png" alt="IDFC First Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/Indusind.png" alt="IndusInd Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/Federal.png" alt="Federal Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/bandhan.png" alt="Bandhan Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/canara.png" alt="Canara Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/punjab.png" alt="PNB" className="bank-logo" /></li>
          </ul>

          {/* Second Row */}
          <ul
            className="banks-row-2"
            onMouseEnter={() => {
              const row = document.querySelector('.banks-row-2');
              if (row) row.style.animationPlayState = 'paused';
            }}
            onMouseLeave={() => {
              const row = document.querySelector('.banks-row-2');
              if (row) row.style.animationPlayState = 'running';
            }}
          >
            <li><img src="/bank-logos/Central.png" alt="Central Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/boi.png" alt="Bank of India" className="bank-logo" /></li>
            <li><img src="/bank-logos/uco.png" alt="UCO Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/over.png" alt="IOB" className="bank-logo" /></li>
            <li><img src="/bank-logos/idbi.png" alt="IDBI Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/south.jpg" alt="South Indian Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/city.png" alt="City Union Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/karur.png" alt="Karur Vysya Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/Karnataka.png" alt="Karnataka Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/rbl.png" alt="RBL Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/au.png" alt="AU Small Finance Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/eq.png" alt="Equitas Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/esaf.png" alt="ESAF Bank" className="bank-logo" /></li>
            <li><img src="/bank-logos/sury.png" alt="Suryoday Bank" className="bank-logo" /></li>
          </ul>
        </div>
      </section >
    </div>
  );
};

export default BankingPartner;
